<script>
import { bad_request, detail_response, flat_errors } from "@/services/helpers";
import { ERROR_MESSAGE } from "@/constants";
import { SECOND } from "@/utils/utils";

export default {
  computed: {},
  methods: {
    /*
    Process await request and show an error if there was an error
    Return true if request is succeeded, otherwise false
     */
    async _executeRequest(future) {
      try {
        const result = await future;
        return result || true;
      } catch (error) {
        this.processError(error);
        this.loading = false;
        this.saving = false;
        return false;
      }
    },
    processError(error) {
      const toastOptions = { duration: 10 * SECOND };
      if (bad_request(error) && detail_response(error)) {
        this.$toast.error(error.response.data.detail, toastOptions);
      } else if (bad_request(error)) {
        this.$toast.error(flat_errors(error.response.data), toastOptions);
      } else {
        console.log(error);
        this.$toast.error(ERROR_MESSAGE.unknown, toastOptions);
      }
    },
  },
};
</script>
